import { NetworkRequest } from '../Utilities/NetworkRequests/NetworkRequests';

export const getSiteRequests = async (params) =>
  NetworkRequest('sites', params);

export const getEmailRequests = async (params) =>
  NetworkRequest('emailDenylist', params);

export const getTYRequests = async (params) => NetworkRequest('ty', params);
